import { Order as ServerCommentOrder, } from '@wix/ambassador-comments-middleware-v1-enriched-comment/types';
import { unreachable } from '../../ts-utils';
import { Ordering } from '../common-enums';
export const commentOrderingToSorting = ({ ordering }) => {
    switch (ordering) {
        case Ordering.NEWEST_FIRST:
            return { order: ServerCommentOrder.NEWEST_FIRST };
        case Ordering.OLDEST_FIRST:
            return { order: ServerCommentOrder.OLDEST_FIRST };
        case Ordering.MOST_REACTIONS_FIRST:
            return { order: ServerCommentOrder.REACTION_COUNT };
        case Ordering.LEAST_VOTES_FIRST:
            return { order: ServerCommentOrder.NET_VOTE_COUNT_ASC };
        case Ordering.MOST_VOTES_FIRST:
            return { order: ServerCommentOrder.NET_VOTE_COUNT };
        case Ordering.HIGHEST_RATED_FIRST:
            return { order: ServerCommentOrder.RATING };
        case Ordering.LOWEST_RATED_FIRST:
            return { order: ServerCommentOrder.RATING_ASC };
        default:
            throw unreachable(ordering);
    }
};
//# sourceMappingURL=ordering-to-sort.js.map